<template>
  <div class="week atb-flex atb-flex-column">
    <div class="header atb-flex atb-flex-items-center">
      <div class="week-title">
        <h2>{{ this.detail.resWkName ? this.detail.title + ' / ' + this.detail.resWkName : '' }}</h2>
        <span class="saveStatus">{{ saveStatus }}</span>
      </div>
    </div>
    <div class="container atb-content-bg atb-flex atb-flex-column">
      <div class="tab">
        <tab-pane :defaultIndex="currentTab" :tab-list="tabList" iconStyle="top" @getCurrent="getCurrent"></tab-pane>
      </div>
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('search')" @submit.native.prevent>
          <el-form-item class="flex-form-item" label="类别">
            <el-autocomplete v-model="searchParam.WorkItemCategory" :fetch-suggestions="querySearch"></el-autocomplete>
          </el-form-item>
          <el-form-item class="flex-form-item" label="分类">
            <el-select clearable v-model="searchParam.WorkClassify" placeholder="分类">
              <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="完成情况">
            <el-select clearable v-model="searchParam.CompleteStatus" placeholder="完成情况">
              <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="flex-form-item" label="关键字">
            <el-input :minlength="2" v-model="searchParam.KeyWord" placeholder="工作项目"></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" class="atb-input">
          <el-form-item>
            <el-radio-group v-model="model" @change="changeModel">
              <el-radio label="1">完整模式</el-radio>
              <el-radio label="2">计划模式</el-radio>
              <el-radio label="3">总结模式</el-radio>
              <el-radio label="4">汇报模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('search')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="deleteDetails">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
              <el-button type="import" plain class="menu-button">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="a">本周目标完成时间</el-dropdown-item>
                <el-dropdown-item command="b">总目标完成时间</el-dropdown-item>
                <el-dropdown-item command="c">完成情况</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" :disabled="pending" @click="saveAll">保存</el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <div v-show="currentTab === 0" class="kpi table-content atb-flex atb-flex-column">
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.week, tableColumn, 'kpi')">
          <i :class="[isCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class="atb-table header-table edit-table border-table disable-ellipsis"
          border="full"
          height="100%"
          auto-resize
          resizable
          :data="tableData"
          ref="week"
          :merge-cells="mergeCells"
          :row-class-name="setRowClass"
          @cell-click="expandRow"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          @edit-closed="editClosed"
          @edit-actived="activeRow"
          :edit-rules="validRules"
        >
          <vxe-table-column type="checkbox" width="40" align="center">
            <template #checkbox="scope">
              <template v-if="scope.rowIndex === 0">
                <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                  <div>
                    <i @click="expandKpi" :class="[expandKpiStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandKpi">KPI工作</span>
                  </div>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
                <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                  <div>
                    <i @click="expandCreate" :class="[expandCreateStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandCreate">问题及创新工作</span>
                  </div>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + createLength + 2">
                <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                  <div>
                    <i @click="expandOther" :class="[expandOtherStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                    <span @click="expandOther">其他新增工作</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <span
                  title="选择/取消"
                  :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']"
                  @click.stop="selectSingle(scope.row)"
                >
                  <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                </span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column width="40" title="源">
            <template #default="{row}">
              <div class="atb-flex atb-flex-items-center">
                <i v-if="row.source === 1" class="icon-tubiao-99 source-icon add"></i>
                <i v-else-if="row.source === 2" class="icon-tubiao-97 source-icon pre"></i>
                <i v-else-if="row.source === 3" class="icon-tubiao-99 source-icon self"></i>
                <i v-else-if="row.source === 5" class="icon-tubiao-96 source-icon year"></i>
                <i v-else-if="row.source === 7" class="icon-zhuan source-icon zhuan"></i>
                <i v-else-if="row.source === 8" class="icon-jiao source-icon jiao"></i>
                <i v-else-if="row.source === 9" class="icon-todo-work source-icon todo"></i>
                <i v-else></i>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
            <template #default="scope">
              <span v-if="scope.rowIndex <= kpiLength">{{ scope.rowIndex }}</span>
              <span v-else-if="scope.rowIndex > kpiLength + 1 && scope.rowIndex <= createLength + kpiLength + 2">{{
                scope.rowIndex - kpiLength - 1
              }}</span>
              <span v-else>{{ scope.rowIndex - kpiLength - createLength - 2 }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="120"
            field="workItemCategory"
            title="类别"
            :edit-render="{ name: 'ElAutocomplete', autofocus: '.el-textarea__inner' }"
          >
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
            </template>
            <template #edit="{ row }">
              <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="querySearch">
                <template slot-scope="{ item }">
                  <el-tooltip class="item" effect='dark' :content="item.value" placement="right-start">
                    <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                  </el-tooltip>
                </template>
              </el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="300"
            field="workItemContent"
            title="工作项目"
            :edit-render="{autofocus: '.el-textarea__inner' }"
          >
            <template #edit="{ row }">
              <el-input
                :autosize="{ maxRows: 8 }"
                :maxlength="$config.input.textareaMaxLength"
                type="textarea"
                placeholder="请输入内容"
                v-model="row.workItemContent"
              ></el-input>
            </template>
            <template #default="scope">
              <div
                @contextmenu.prevent="popupHistory(scope.row)"
                :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']"
              >{{ scope.row.workItemContent }}
                <el-popover
                  placement="right"
                  v-if="scope.row.isPublished == 1"
                  width="416"
                  height="200"
                  popper-class="history"
                  trigger="hover"
                  @show="getAddWork(scope.row)"
                  :visible-arrow="false"
                >
                  <el-checkbox-group v-model="checkList" class="program-check">
                    <li class="atb-flex" v-for="item in programData" :key="item.id">
                      <el-checkbox :label="item.id">
                        <span>{{ item.resWkName }}</span>
                      </el-checkbox>
                      <div>
                        <p class="desc">{{ item.workItemContent }}</p>
                        <p class="date">{{ $formatTime(item.currentWeekFinishDate, 'yyyy-MM-dd') }}</p>
                      </div>
                    </li>
                  </el-checkbox-group>
                  <div class="footer">
                    <el-checkbox class="select-all-program" @change="checkAll" v-model="selectAllProgram">全选</el-checkbox>
                    <el-button class="atb-dialog-confirm copy" type="primary" @click="copyProgram">复制</el-button>
                  </div>
                  <span slot="reference" class="program-tip">
                    <i class="icon-synchronize"></i>
                  </span>
                </el-popover>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="80" field="resWkName" title="责任人" :edit-render="{ enabled: false }">
            <template #edit="{ row }">
              <el-input type="textarea" placeholder="请输入内容" v-model="row.resWkName"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="300"
            field="wholeTarget"
            title="总目标"
            :edit-render="{ autofocus: '.el-textarea__inner' }"
          >
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
            </template>
            <template #edit="{ row }">
              <el-input
                type="textarea"
                :autosize="{ maxRows: 8 }"
                :maxlength="$config.input.textareaMaxLength"
                placeholder="请输入内容"
                v-model="row.wholeTarget"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="150"
            field="finishDate"
            title="总目标完成时间"
            :edit-render="{ autofocus: '.el-input__inner'}"
          >
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column
            min-width="300"
            field="currentWeekTarget"
            title="本周需达到的目标"
            :edit-render="{ autofocus: '.el-textarea__inner'}"
          >
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.currentWeekTarget }}</div>
            </template>
            <template #edit="{ row }">
              <el-input
                type="textarea"
                :maxlength="$config.input.textareaMaxLength"
                :autosize="{ maxRows: 8 }"
                placeholder="请输入内容"
                v-model="row.currentWeekTarget"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="160"
            field="currentWeekFinishDate"
            title="本周目标完成时间"
            :edit-render="{ autofocus: '.el-input__inner'}"
          >
            <template #edit="{ row }">
              <el-date-picker v-model="row.currentWeekFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column min-width="100" field="weight" title="权重" :edit-render="{ autofocus: '.el-input__inner'}">
            <template #edit="{ row }">
              <el-autocomplete @change="regWeight(row)" v-model.trim="row.weight" :fetch-suggestions="weightSearch"></el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="100"
            field="isImportantWork"
            title="重点关注"
            :edit-render="{ name: 'ElSelect', autofocus: '.el-input__inner'}"
          >
            <template #default="{row}">
              <span v-if="row.isImportantWork == 0">否</span>
              <span v-if="row.isImportantWork == 1">是</span>
            </template>
            <template #edit="scope">
              <el-select v-model="scope.row.isImportantWork" @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in importantList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="100"
            field="completeStatus"
            title="完成情况"
            :edit-render="{ name: 'ElSelect', options: completeList, autofocus: '.el-input__inner' }"
          >
            <template #default="{row}">
              <!-- <span v-if="row.completeStatus == 0">计划</span> -->
              <span v-if="row.completeStatus == 10">未完成</span>
              <span v-if="row.completeStatus == 20">周目标完成</span>
              <span v-if="row.completeStatus == 25">总目标完成</span>
              <span v-if="row.completeStatus == 30">延迟</span>
              <span v-if="row.completeStatus == 40">转移</span>
              <span v-if="row.completeStatus == 50">关闭</span>
            </template>
            <template #edit="scope">
              <el-select v-model="scope.row.completeStatus" @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="300" field="reason" title="总结" :edit-render="{ autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
            </template>
            <template #edit="{ row }">
              <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.reason"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="300" field="remark" title="备注" :edit-render="{ autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
            </template>
            <template #edit="{ row }">
              <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.remark"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column fixed="right" min-width="160" field="status" title="提交状态">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 10" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 20" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 30" type="close" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 35" type="delay" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 40" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 50" type="close" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-popover
                placement="top"
                v-if="row.status === 30 || row.status === 50"
                width="300"
                popper-class="reason"
                @show="getAddWork(scope.row)"
                :visible-arrow="false"
              >
                <div>
                  {{ row.approveReason || '无' }}
                </div>
                <span slot="reference" class="program-tip reason">
                  <i class="icon-hint"></i>
                </span>
              </el-popover>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed="right" min-width="180" class-name="operation">
            <template #default="scope">
              <div>
                <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                  <i v-throttle class="icon-baocun" @click.stop="save(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i v-throttle class="icon-close delete" @click.stop="deleteData(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.id" class="item" effect="dark" content="切换分类" placement="bottom">
                  <i class="icon-move" @click.stop="move(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div v-show="currentTab === 1" class="normal table-content atb-flex atb-flex-column">
        <div v-show="showCollapse" class="collapse" @click="collapse($refs.normal, normalColumn, 'normal')">
          <i :class="[isNormalCollapse ? 'icon-zhankai' : 'icon-shouqi']"></i>
        </div>
        <vxe-table
          class="atb-table header-table edit-table border-table disable-ellipsis"
          border="full"
          height="100%"
          auto-resize
          resizable
          :data="normalTableData"
          ref="normal"
          :merge-cells="mergeNormal"
          :row-class-name="setNormalRowClass"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          @edit-closed="editNormalClose"
          @edit-actived="activeNormalRow"
          @cell-click="expandNormalRow"
          :edit-rules="validRules"
        >
          <vxe-table-column type="checkbox" width="40" align="center">
            <template #checkbox="scope">
              <template v-if="scope.rowIndex === 0">
                <div class="kpi-add atb-flex atb-flex-justify-between atb-flex-items-center">
                  <div>
                    <span>例行工作</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <span
                  title="选择/取消"
                  :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']"
                  @click.stop="selectNormalSingle(scope.row)"
                >
                  <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                </span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column width="40" title="源">
            <template #default="{row}">
              <div class="atb-flex atb-flex-items-center">
                <i v-if="row.source === 1" class="icon-tubiao-99 source-icon add"></i>
                <i v-else-if="row.source === 2" class="icon-tubiao-97 source-icon pre"></i>
                <i v-else-if="row.source === 3" class="icon-tubiao-99 source-icon self"></i>
                <i v-else-if="row.source === 5" class="icon-tubiao-96 source-icon year"></i>
                <i v-else-if="row.source === 7" class="icon-zhuan source-icon zhuan"></i>
                <i v-else-if="row.source === 8" class="icon-jiao source-icon jiao"></i>
                <i v-else-if="row.source === 9" class="icon-todo-work source-icon todo"></i>
                <i v-else></i>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="workItemNo" min-width="50" title="NO." align="center">
            <template #default="scope">
              <span>{{ scope.rowIndex }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="120"
            field="workItemCategory"
            title="类别"
            :edit-render="{ name: 'ElAutocomplete',autofocus: '.el-textarea__inner' }"
          >
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemCategory }}</div>
            </template>
            <template #edit="{ row }">
              <el-autocomplete v-model="row.workItemCategory" type="textarea" :autosize="{ maxRows: 8 }" :fetch-suggestions="querySearch">
                <template slot-scope="{ item }">
                  <el-tooltip class="item" effect='dark' :content="item.value" placement="right-start">
                    <div class="query-item-text atb-ellipsis">{{ item.value }}</div>
                  </el-tooltip>
                </template>
              </el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="300"
            field="workItemContent"
            title="工作项目"
            :edit-render="{autofocus: '.el-textarea__inner' }"
          >
            <template #edit="{ row }">
              <el-input
                :autosize="{ maxRows: 8 }"
                :maxlength="$config.input.textareaMaxLength"
                type="textarea"
                placeholder="请输入内容"
                v-model="row.workItemContent"
              ></el-input>
            </template>
            <template #default="scope">
              <div
                @contextmenu.prevent="popupHistory(scope.row)"
                :class="[scope.row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']"
              >{{ scope.row.workItemContent }}
                <el-popover
                  placement="right"
                  v-if="scope.row.isPublished == 1"
                  width="416"
                  height="200"
                  popper-class="history"
                  trigger="hover"
                  @show="getAddWork(scope.row)"
                  :visible-arrow="false"
                >
                  <el-checkbox-group v-model="checkList" class="program-check">
                    <li class="atb-flex" v-for="item in programData" :key="item.id">
                      <el-checkbox :label="item.id">
                        <span>{{ item.name }}</span>
                      </el-checkbox>
                      <div>
                        <p class="desc">{{ item.address }}</p>
                        <p class="date">{{ item.date }}</p>
                      </div>
                    </li>
                  </el-checkbox-group>
                  <div class="footer">
                    <el-checkbox class="select-all-program" @change="checkAll" v-model="selectAllProgram">全选</el-checkbox>
                    <el-button class="atb-dialog-confirm copy" type="primary" @click="copyProgram">复制</el-button>
                  </div>
                  <span slot="reference" class="program-tip">
                    <i class="icon-synchronize"></i>
                  </span>
                </el-popover>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="80" field="resWkName" title="责任人" :edit-render="{ autofocus: '.el-textarea__inner', enabled: false }">
            <template #edit="{ row }">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="row.resWkName"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="300"
            field="wholeTarget"
            title="总目标"
            :edit-render="{ autofocus: '.el-textarea__inner' }"
          >
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.wholeTarget }}</div>
            </template>
            <template #edit="{ row }">
              <el-input
                type="textarea"
                :autosize="{ maxRows: 8 }"
                :maxlength="$config.input.textareaMaxLength"
                placeholder="请输入内容"
                v-model="row.wholeTarget"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="150"
            field="finishDate"
            title="总目标完成时间"
            :edit-render="{ autofocus: '.el-textarea__inner'}"
          >
            <template #edit="{ row }">
              <el-date-picker v-model="row.finishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column
            min-width="300"
            field="currentWeekTarget"
            title="本周需达到的目标"
            :edit-render="{ autofocus: '.el-textarea__inner'}"
          >
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.currentWeekTarget }}</div>
            </template>
            <template #edit="{ row }">
              <el-input
                type="textarea"
                :autosize="{ maxRows: 8 }"
                :maxlength="$config.input.textareaMaxLength"
                placeholder="请输入内容"
                v-model="row.currentWeekTarget"
              ></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="160"
            field="currentWeekFinishDate"
            title="本周目标完成时间"
            :edit-render="{ autofocus: '.el-textarea__inner'}"
          >
            <template #edit="{ row }">
              <el-date-picker v-model="row.currentWeekFinishDate" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column min-width="100" field="weight" title="权重" :edit-render="{ autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-autocomplete @change="regWeight(row)" v-model.trim="row.weight" :fetch-suggestions="weightSearch"></el-autocomplete>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="100"
            field="isImportantWork"
            title="重点关注"
            :edit-render="{ name: 'ElSelect', autofocus: '.el-input__inner' }"
          >
            <template #default="{row}">
              <span v-if="row.isImportantWork == 0">否</span>
              <span v-if="row.isImportantWork == 1">是</span>
            </template>
            <template #edit="scope">
              <el-select v-model="scope.row.isImportantWork" @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in importantList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column
            min-width="100"
            field="completeStatus"
            title="完成情况"
            :edit-render="{ name: 'ElSelect', options: completeList, autofocus: '.el-input__inner' }"
          >
            <template #default="{row}">
              <!-- <span v-if="row.completeStatus == 0">计划</span> -->
              <span v-if="row.completeStatus == 10">未完成</span>
              <span v-if="row.completeStatus == 20">周目标完成</span>
              <span v-if="row.completeStatus == 25">总目标完成</span>
              <span v-if="row.completeStatus == 30">延迟</span>
              <span v-if="row.completeStatus == 40">转移</span>
              <span v-if="row.completeStatus == 50">关闭</span>
            </template>
            <template #edit="scope">
              <el-select v-model="scope.row.completeStatus" @change="$refs.week.updateStatus(scope)">
                <el-option v-for="item in completeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="300" field="reason" title="总结" :edit-render="{ autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.reason }}</div>
            </template>
            <template #edit="{ row }">
              <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.reason"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="300" field="remark" title="备注" :edit-render="{ autofocus: '.el-textarea__inner'}">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
            </template>
            <template #edit="{ row }">
              <el-input :maxlength="$config.input.textareaMaxLength" type="textarea" :autosize="{ maxRows: 8 }" placeholder="请输入内容" v-model="row.remark"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column fixed="right" min-width="160" field="status" title="提交状态">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 10" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 20" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 30" type="close" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 35" type="delay" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 40" type="complete" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-tag v-if="row.status === 50" type="close" effect="dark">
                {{ getStatusName(row.status) }}
              </el-tag>
              <el-popover
                placement="top"
                v-if="row.status === 30 || row.status === 50"
                width="300"
                popper-class="reason"
                @show="getAddWork(scope.row)"
                :visible-arrow="false"
              >
                <div>
                  {{ row.approveReason || '无' }}
                </div>
                <span slot="reference" class="program-tip reason">
                  <i class="icon-hint"></i>
                </span>
              </el-popover>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" fixed="right" min-width="180" class-name="operation">
            <template #default="scope">
              <div>
                <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                  <i v-throttle class="icon-baocun" @click.stop="saveNormal(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i v-throttle class="icon-close delete" @click.stop="deleteNormal(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
                <el-tooltip v-if="scope.row.id" class="item" effect="dark" content="切换分类" placement="bottom">
                  <i class="icon-move" @click.stop="move(scope.row, scope.rowIndex)"></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <el-dialog title="转移工作分类" :visible.sync="showHandle" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <el-radio-group v-model="classify">
          <el-radio-button :key="item.label + item.value" v-for="item in classifyList" :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmClassify">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="历史工作项内容" custom-class="history-dialog" :visible.sync="showHistory" width="1200px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <vxe-table class="atb-table header-table edit-table disable-ellipsis" border="full" height="100%" auto-resize resizable :data="historyData" ref="popup">
          <vxe-table-column type="seq" min-width="50" title="NO." align="center"></vxe-table-column>
          <vxe-table-column field="title" min-width="120" title="标题" align="center"></vxe-table-column>
          <vxe-table-column min-width="100" field="workClassify" title="类别">
            <template #default="{row}">
              <span v-if="row.workClassify == 0">KPI工作</span>
              <span v-if="row.workClassify == 10">例行工作</span>
              <span v-if="row.workClassify == 20">问题及创新工作</span>
              <span v-if="row.workClassify == 30">其他新增工作</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="200" field="workItemContent" title="工作项目"></vxe-table-column>
          <vxe-table-column min-width="200" field="wholeTarget" title="总目标"></vxe-table-column>
          <vxe-table-column min-width="200" field="currentWeekTarget" title="本周需达到的目标"></vxe-table-column>
          <!-- <vxe-table-column min-width="150" field="currentWeekFinishDate" title="开始时间">
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column>
          <vxe-table-column min-width="150" field="currentWeekFinishDate" title="结束时间">
            <template #default="{ row }">{{ formatDate(row.currentWeekFinishDate, 'yyyy-MM-dd') }}</template>
          </vxe-table-column> -->
          <vxe-table-column min-width="100" field="completeStatus" title="完成情况">
            <template #default="{row}">
              <span v-if="row.completeStatus == 0">计划</span>
              <span v-if="row.completeStatus == 10">进行中</span>
              <span v-if="row.completeStatus == 20">已完成</span>
              <span v-if="row.completeStatus == 25">总目标完成</span>
              <span v-if="row.completeStatus == 30">延迟</span>
              <span v-if="row.completeStatus == 40">转移</span>
              <span v-if="row.completeStatus == 50">暂停或关闭</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="80" field="reason" title="总结"></vxe-table-column>
        </vxe-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHistory = false">取消</el-button>
      </span>
    </el-dialog>
    <context-menu :data="tableColumn" :selector="`.week .vxe-header--row`" @columnHideToggle="columnHideToggle"></context-menu>
    <common-dialog ref="addSyncDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :from="2" :command="dialogContent.command" :completeList="completeList" :selectData="selecterData" :editData="editData" @submitSuccess="copyLast()"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';
import _ from 'lodash';
import routeMixin from '@/mixins/route.mixin';
export default {
  name: 'index',
  inject: ['reload'],
  mixins: [routeMixin],
  components: {
    batchEdit: () => import('@/pages/personal/week/batchEdit.vue'),
  },
  data() {
    return {
      workId: '',
      childIds: '',
      activeName: 'second',
      currentTab: 0,
      showHandle: false,
      handleDelete: true,
      showHistory: false,
      historyData: [],
      showApprove: false,
      showCompleteApprove: false,
      showSubmit: false,
      tabList: [
        {
          label: 'KPI、问题及创新工作',
          id: 0,
        },
        {
          label: '例行工作',
          id: 1,
        },
      ],
      searchParam: {
        WorkItemCategory: null,
        WorkClassify: null,
        KeyWord: null,
        CompleteStatus: null,
      },
      //列编辑权限控制
      categoryAuth: true, //类别编辑权限
      normalAuth: true, //普通编辑权限
      completeAuth: true, //完成情况权限 ---> 完成情况 原因
      fromOtherAuth: true, // 其他来源权限 ---> 本月需达到目标、本月目标完成时间、是否重点工作、完成情况、原因
      weightAuth: true, //权重权限 ---> 权重
      mergeCells: [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ],
      mergeNormal: [{ row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength }],
      result: {},
      kpi: [],
      normal: [],
      create: [],
      other: [],
      record: {
        workId: '',
        workClassify: 0,
        workItemNo: '',
        workItemCategory: '',
        workItemContent: '',
        resWkNo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkNo : '',
        resWkName: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')).wkName : '',
        wholeTarget: '',
        finishDate: '',
        currentWeekTarget: '',
        currentWeekFinishDate: '',
        weight: 1,
        isImportantWork: 0,
        completeStatus: 0,
        reason: '',
        creatorId: sessionStorage.getItem('LOGIN_NAME'),
        status: 100,
        remark: '',
      },
      classifyList: [
        { label: 'KPI工作', value: 0 },
        { label: '例行工作', value: 10 },
        { label: '问题及创新工作', value: 20 },
        { label: '其他新增工作', value: 30 },
      ],
      categoryList: [],
      completeList: [
        // { label: '计划', value: 0 },
        { label: '未完成', value: 10 },
        { label: '周目标完成', value: 20 },
        { label: '总目标完成', value: 25 },
        { label: '延迟', value: 30 },
        // {label: '转移', value: 40},
        { label: '关闭', value: 50 },
      ],
      statusList: [],
      importantList: [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
      programList: [{ value: 'A2000plus' }, { value: 'A1000plus' }, { value: '远程项目' }],
      weightList: [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }],
      unHandleList: [],
      handledList: [],
      allChecked: false,
      programData: [],
      checkList: [],
      selectAllProgram: false,
      isChecked: false,
      status: 0,
      idList: [],
      detail: {},
      timer: null,
      classify: '',
      nowClassify: {},
      row: {},
      rowIndex: 0,
      normalRow: {},
      normalRowIndex: 0,
      tableColumn: [],
      normalColumn: [],
      expandKpiStatus: true,
      expandNormalStatus: true,
      expandCreateStatus: true,
      expandOtherStatus: true,
      editStatus: 'edit',
      cloneTableData: [], //克隆数据 保存最新的完整数据做数据传输
      cloneNormalTableData: [],
      model: '1',
      approveReason: '',
      approveRow: null,
      that: this,
      saveStatus: '',
      timeoutSave: '',
      timeoutAutoSave: '',
      timeoutSaveNormal: '',
      timeoutAutoSaveNormal: '',
      cloneKpi: [],
      cloneBudget: [],
      cloneCreate: [],
      cloneOther: [],
      disabledApprove: false,
      isCollapse: false,
      isNormalCollapse: false,
      showCollapse: false,
      pending: false,
      dialogContent: {},
      editData: {},
    };
  },
  computed: {
    kpiLength() {
      //kpi数据长度 动态增加数据使用
      return this.kpi.length;
    },
    normalLength() {
      return this.normal.length;
    },
    createLength() {
      return this.create.length;
    },
    otherLength() {
      return this.other.length;
    },
    tableData: {
      get() {
        return [{}, ...this.kpi, {}, ...this.create, {}, ...this.other];
      },
      set(v) {
        console.log(v);
      },
    },
    tableColumnLength() {
      return this.tableColumn.filter((val) => val.visible !== false).length;
    },
    normalColumnLength() {
      return this.normalColumn.filter((val) => val.visible !== false).length;
    },
    normalTableData() {
      return [{}, ...this.normal];
    },
  },
  created() {
    this.workId = this.$route.query.id || '';
    this.record.workId = this.workId;
    this.getWorkItemStatus().then(() => {
      this.getList();
    });
    this.getCategory();
  },
  mounted() {
    // document.addEventListener('keydown', this.saveContent)
    this.$nextTick(() => {
      this.tableColumn = this.$refs.week.getColumns();
      this.normalColumn = this.$refs.normal.getColumns();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    // document.removeEventListener('keydown', this.saveContent)
  },
  methods: {
    deleteDetails() {
        if (this.currentTab === 0) {
          this.selecterData = this.$refs.week.getCheckboxRecords().filter(val => val.workId !== undefined);
        } else {
          this.selecterData = this.$refs.normal.getCheckboxRecords().filter(val => val.workId !== undefined);
        }
        if (this.selecterData.length == 0) {
          this.$message.error('请先选择数据');
          return false;
        }
        this.$confirm('确定要删除吗', '删除', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          const sel = this.selecterData.map(v => v.id);
          //  _.remove(this.tableData, function(item, i) {
          //   return sel[i];
          // });
          // this.tableData.splice(0,0);
          this.$ajax.post(this.$api.workManage.week.delete, sel).then(() => {
            this.$message.success('删除成功');
            this.getList();
          })
        })
        
      },
      handleCommand(command) {
        if (this.currentTab === 0) {
          this.selecterData = this.$refs.week.getCheckboxRecords().filter(val => val.workId !== undefined);
        } else {
          this.selecterData = this.$refs.normal.getCheckboxRecords().filter(val => val.workId !== undefined);
        }
        if (this.selecterData.length == 0) {
          this.$message.error('请先选择数据');
          return false;
        }
        this.dialogContent = {
          title: '批量操作',
          componentName: 'batchEdit',
          width: '450px',
          command: command
        };
        this.editData.workId = this.workId;
        this.$refs.addSyncDialog.show();
      },
    getStatusName(val) {
      const obj = this.statusList.find((t) => t.itemValue == val);
      return obj ? obj.itemDesc : '';
    },
    async getWorkItemStatus() {
      await this.$ajax.get(this.$api.common.getDict, { ItemType: 'WorkItemStatus' }).then((res) => {
        this.statusList = (res.data && res.data.rows) || [];
      });
    },
    regWeight(row) {
      let reg = new RegExp('^([1-9]|[1-9]\\d|100)$');
      if (!reg.test(row.weight)) {
        if (row.weight - 0 > 100) {
          row.weight = 100;
        } else {
          row.weight = 1;
        }
      }
    },
    collapse(el, column, table) {
      if (table === 'kpi') {
        this.isCollapse = !this.isCollapse;
        if (this.isCollapse) {
          column.forEach((val) => {
            if (val.title == '操作' || val.title == '提交状态') {
              val.visible = false;
            }
          });
          el && el.refreshColumn();
          this.setPosition('reset', table);
        } else {
          column
            .filter((val) => val.title == '操作' || val.title == '提交状态')
            .forEach((val) => {
              val.visible = true;
            });
          el && el.refreshColumn();
          setTimeout(() => {
            this.setPosition(null, table);
            // this.observerClass(table);
          }, 50);
        }
      } else {
        this.isNormalCollapse = !this.isNormalCollapse;
        if (this.isNormalCollapse) {
          column.forEach((val) => {
            if (val.title == '操作' || val.title == '提交状态') {
              val.visible = false;
            }
          });
          el && el.refreshColumn();
          this.setPosition('reset', table);
        } else {
          column
            .filter((val) => val.title == '操作' || val.title == '提交状态')
            .forEach((val) => {
              val.visible = true;
            });
          el && el.refreshColumn();
          setTimeout(() => {
            this.setPosition(null, table);
            // this.observerClass(table);
          }, 50);
        }
      }
    },
    setPosition(reset, table) {
      this.showCollapse = true;
      if (reset) {
        if (table === 'kpi') {
          document.getElementsByClassName('collapse')[0].style.right = 0;
        } else {
          document.getElementsByClassName('collapse')[1].style.right = 0;
        }
      } else {
        if (table === 'kpi') {
          const left = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0].offsetWidth;
          const height = document.getElementsByClassName('table-content')[0].offsetHeight;
          document.getElementsByClassName('collapse')[0].style.top = height / 2 - 15 + 'px';
          document.getElementsByClassName('collapse')[0].style.right = left + 'px';
        } else {
          const left = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[1].offsetWidth;
          const height = document.getElementsByClassName('table-content')[1].offsetHeight;
          document.getElementsByClassName('collapse')[1].style.top = height / 2 - 15 + 'px';
          document.getElementsByClassName('collapse')[1].style.right = left + 'px';
        }
        //判断有无滚动条
        // const client = document.getElementsByClassName("vxe-table--body-wrapper")[0].clientWidth;
        // const offset = document.getElementsByClassName("vxe-table--body-wrapper")[0].offsetWidth;
        // if (client === offset) {
        //   document.getElementsByClassName("collapse")[0].style.right = left + "px";
        // }else {
        //   document.getElementsByClassName("collapse")[0].style.right = (left + offset - client) + "px";
        // }
      }
    },
    observerClass(table) {
      let targetNode;
      // 选择需要观察变动的节点
      if (table === 'kpi') {
        targetNode = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[0];
      } else {
        targetNode = document.getElementsByClassName('vxe-table--fixed-right-wrapper')[1];
      }
      // 观察器的配置（需要观察什么变动）
      const config = { attributes: true, attributeFilter: ['class', 'style'] };
      // 当观察到变动时执行的回调函数
      const callback = function(mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        const classList = mutationsList[0].target.classList;
        // console.log(classList);
        if (classList.length == 1) {
          if (table === 'kpi') {
            document.getElementsByClassName('collapse')[0].style.display = 'none';
          } else {
            document.getElementsByClassName('collapse')[1].style.display = 'none';
          }
        } else {
          if (table === 'kpi') {
            document.getElementsByClassName('collapse')[0].style.display = 'block';
          } else {
            document.getElementsByClassName('collapse')[1].style.display = 'block';
          }
        }
      };
      // 创建一个观察器实例并传入回调函数
      const observer = new MutationObserver(callback);
      // 以上述配置开始观察目标节点
      observer.observe(targetNode, config);
      // 之后，可停止观察
      // observer.disconnect();
    },
    // 列隐藏展示切换
    columnHideToggle(d) {
      let val = this.tableColumn.find((row) => row.title == d.title);
      let val2 = this.normalColumn.find((row) => row.title == d.title);
      if (val && val2) {
        val.visible = !val.visible;
        val2.visible = !val2.visible;
        this.$refs.week && this.$refs.week.refreshColumn();
        this.$refs.normal && this.$refs.normal.refreshColumn();
      }
    },
    saveContent(e) {
      let key = window.event.keyCode ? window.event.keyCode : window.event.which;
      if (key === 83 && e.ctrlKey) {
        e.preventDefault();
        this.saveAll();
      }
    },
    getCurrent(item) {
      this.currentTab = item.data.id;
      if (this.currentTab === 1) {
        this.$refs.normal.refreshColumn();
        setTimeout(() => {
          if (this.isNormalCollapse) {
            this.setPosition('reset', 'normal');
          } else {
            this.setPosition(null, 'normal');
            // this.observerClass("normal");
          }
        }, 50);
      } else {
        this.$refs.week.refreshColumn();
        setTimeout(() => {
          if (this.isCollapse) {
            this.setPosition('reset', 'kpi');
          } else {
            this.setPosition(null, 'kpi');
            // this.observerClass("kpi");
          }
        }, 50);
      }
    },
    getCategory() {
      this.$ajax.get(this.$api.Identity.Categord.categoryByNo, { userId: sessionStorage.getItem('LOGIN_NAME') }).then((res) => {
        const item = res.data;
        this.categoryList = this.filterCategory(item);
      });
    },
    getList(search) {
      let param = Object.assign({ WorkId: this.workId }, this.searchParam, this.page);
      this.$ajax.get(this.$api.workManage.week.list, param).then((res) => {
        //判断审批状态下是否所有工作项内容都已审批过
        const result = res.data.detailDtoList;
        this.filterTableData(result);
        //获取右侧第二列的位置信息
        setTimeout(() => {
          this.setPosition(null, 'kpi');
          // this.observerClass("kpi");
          if (this.currentTab === 1) {
            this.setPosition(null, 'normal');
            // this.observerClass("normal");
          }
        }, 50);
        this.setMerge();
        this.setNormalMerge();
        this.detail = res.data.weekWorkDto;
        if (result.length === 0) {
          this.tableData = [{}, {}, {}, {}];
        }
        this.cloneTableData = _.cloneDeep(this.tableData);
        this.cloneNormalTableData = _.cloneDeep(this.normalTableData);
      });
    },
    filterTableData(tableData) {
      this.kpi = tableData.filter((val) => val.workClassify == 0);
      this.normal = tableData.filter((val) => val.workClassify == 10);
      this.create = tableData.filter((val) => val.workClassify == 20);
      this.other = tableData.filter((val) => val.workClassify == 30);
    },
    getAllTableData() {
      //获取所有工作项的数据
      let relResult = [];
      if (this.cloneKpi.length) {
        relResult = relResult.concat(this.cloneKpi);
      } else {
        relResult = relResult.concat(this.kpi);
      }
      if (this.cloneCreate.length) {
        relResult = relResult.concat(this.cloneCreate);
      } else {
        relResult = relResult.concat(this.create);
      }
      if (this.cloneOther.length) {
        relResult = relResult.concat(this.cloneOther);
      } else {
        relResult = relResult.concat(this.other);
      }
      return [...relResult, ...this.normal];
    },
    selectSingle(row) {
      this.$refs.week.toggleCheckboxRow(row);
    },
    selectNormalSingle(row) {
      this.$refs.normal.toggleCheckboxRow(row);
    },
    addKpi() {
      if (!this.expandKpiStatus) {
        this.expandKpiStatus = true;
        this.kpi = _.cloneDeep(this.cloneKpi);
        this.cloneKpi = [];
      }
      const $table = this.$refs.week;
      this.record.workItemNo = (this.kpiLength + 1).toString();
      this.kpi.push(_.cloneDeep(this.record));
      $table.setActiveRow(this.tableData[this.kpiLength]);
    },
    async addNormal() {
      const $table = this.$refs.normal;
      this.record.workItemNo = (this.normalLength + 1).toString();
      let normalItem = _.cloneDeep(this.record);
      normalItem.workClassify = 10;
      this.normal.push(normalItem);
      await $table.setActiveRow(this.normalTableData[this.normalLength]);
    },
    async addCreate() {
      if (!this.expandCreateStatus) {
        this.expandCreateStatus = true;
        this.create = _.cloneDeep(this.cloneCreate);
        this.cloneCreate = [];
      }
      const $table = this.$refs.week;
      this.record.workItemNo = (this.createLength + 1).toString();
      let createItem = _.cloneDeep(this.record);
      createItem.workClassify = 20;
      this.create.push(createItem);
      console.log(this.tableData[this.kpiLength + 1 + this.createLength]);
      await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.createLength]);
    },
    async addOther() {
      if (!this.expandOtherStatus) {
        this.expandOtherStatus = true;
        this.other = _.cloneDeep(this.cloneOther);
        this.cloneOther = [];
      }
      const $table = this.$refs.week;
      this.record.workItemNo = (this.otherLength + 1).toString();
      let otherItem = _.cloneDeep(this.record);
      otherItem.workClassify = 30;
      this.other.push(otherItem);
      await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.createLength + this.otherLength]);
    },
    setRowClass({ rowIndex }) {
      if (rowIndex == 0 || rowIndex == this.kpiLength + 1 || rowIndex == this.kpiLength + this.createLength + 2) {
        return 'main-row';
      }
    },
    setNormalRowClass({ rowIndex }) {
      if (rowIndex == 0) {
        return 'main-row';
      }
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    
    saveAll() {
      const arr = this.getAllTableData();
      this.$ajax.post(this.$api.week.WeekWorkDetail.addAll, arr, { noLoading: true }).then((res) => {
        this.$message.success('保存成功');
      });
    },
    editClosed({ row, rowIndex }) {
      delete row._X_ID;
      delete this.cloneTableData[rowIndex]._X_ID;
      if (_.isEqual(row, this.cloneTableData[rowIndex])) {
        return false;
      }
      this.row = {};
      this.rowIndex = 0;
      if (this.buttonSave) {
        return false;
      }
      if (rowIndex !== -1) {
        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
          .then(() => {
            this.saveService(this.tableData[rowIndex], rowIndex);
          })
          .catch(() => {
            if (row.id) {
              this.writeRow(this.cloneTableData[rowIndex], rowIndex);
              this.setMerge();
            } else {
              this.deleteData(row, rowIndex, 0);
            }
          });
      }
    },
    save(row, rowIndex) {
      delete row._X_ID;
      delete this.cloneTableData[rowIndex]._X_ID;
      if (_.isEqual(row, this.cloneTableData[rowIndex])) {
        return false;
      }
      this.buttonSave = true;
        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
          .then(() => {
            this.buttonSave = false;
            this.saveService(this.tableData[rowIndex], rowIndex);
          })
          .catch(() => {
            this.buttonSave = false;
            if (row.id) {
              this.writeRow(this.cloneTableData[rowIndex], rowIndex);
              delete this.cloneTableData[rowIndex]._X_ID;
              this.setMerge();
            } else {
              this.deleteData(row, rowIndex, 0);
            }
          });
    },
    async saveService(row, index) {
      this.pending = true;
      this.tableData[index].weight = this.tableData[index].weight ? this.tableData[index].weight : 1;
      await this.$ajax
        .post(this.$api.workManage.week.updateDetail, [this.tableData[index]], { noLoading: true })
        .then((res) => {
          const item = res.data && res.data[0];
          this.writeRow(item, index);
          this.cloneTableData = _.cloneDeep(this.tableData);
          this.saveStatus = '已保存';
          this.timeoutSave && clearTimeout(timeoutSave);
          const timeoutSave = setTimeout(
            () => {
              this.saveStatus = '';
            },
            1000,
            this
          );
          this.$nextTick(() => {
            this.setMerge();
          });
          this.pending = false;
        })
        .catch(() => {
          this.pending = false;
        });
    },
    writeRow(row, index) {
      let item = _.cloneDeep(row);
      if (item.workClassify === 0) {
        if (this.expandKpiStatus) {
          this.kpi.splice(index - 1, 1, item);
        } else {
          this.cloneKpi.splice(index - 1, 1, item);
          }
        } else if (item.workClassify === 20) {
          if (this.expandCreateStatus) {
            this.create.splice(index - this.kpiLength - 2, 1, item);
          } else {
            this.cloneCreate.splice(index - this.kpiLength - 2, 1, item);
          }
        } else if (item.workClassify === 30) {
          if (this.expandOtherStatus) {
            this.other.splice(index - this.kpiLength - this.createLength - 3, 1, item);
          } else {
            this.cloneOther.splice(index - this.kpiLength - this.createLength - 3, 1, item);
          }
        }
    },
    editNormalClose({ row, rowIndex }) {
      delete row._X_ID;
      delete this.cloneNormalTableData[rowIndex]._X_ID;
      if (_.isEqual(row, this.cloneNormalTableData[rowIndex])) {
        return false;
      }
      this.normalRow = {};
      this.normalRowIndex = 0;
      if (rowIndex !== -1) {
        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
          .then(() => {
            this.saveNormalService(this.normalTableData[rowIndex], rowIndex);
          })
          .catch(() => {
            if (row.id) {
              this.normal.splice(rowIndex - 1, 1, _.cloneDeep(this.cloneNormalTableData[rowIndex]));
              this.setNormalMerge();
            } else {
              this.deleteNormal(row, rowIndex, 0);
            }
          });
      }
    },
    saveNormal(row, rowIndex) {
      delete row._X_ID;
      delete this.cloneNormalTableData[rowIndex]._X_ID;
      if (_.isEqual(row, this.cloneNormalTableData[rowIndex])) {
        return false;
      }
      this.buttonSave = true;
        this.$confirm('确定要修改吗', '修改', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        })
          .then(() => {
            this.buttonSave = false;
            this.saveNormalService(this.normalTableData[rowIndex], rowIndex);
          })
          .catch(() => {
            this.buttonSave = false;
            if (row.id) {
              this.normal.splice(rowIndex - 1, 1, _.cloneDeep(this.cloneNormalTableData[rowIndex]));
              this.setNormalMerge();
            } else {
              this.deleteNormal(row, rowIndex, 0);
            }
          });
    },
    async saveNormalService(row, index) {
      this.pending = true;
      this.normalTableData[index].weight = this.normalTableData[index].weight ? this.normalTableData[index].weight : 1;
      await this.$ajax
        .post(this.$api.workManage.week.updateDetail, [this.normalTableData[index]], { noLoading: true })
        .then((res) => {
          const item = res.data && res.data[0];
          this.normal.splice(index - 1, 1, item);
          this.cloneNormalTableData = _.cloneDeep(this.normalTableData);
          this.saveStatus = '已保存';
          this.timeoutSaveNormal && clearTimeout(timeoutSaveNormal);
          const timeoutSaveNormal = setTimeout(
            () => {
              this.saveStatus = '';
            },
            1000,
            this
          );
          this.$nextTick(() => {
            this.setNormalMerge();
          });
          this.pending = false;
        })
        .catch(() => {
          this.pending = false;
        });
    },
    activeRow({ row, rowIndex }) {
      this.row = row;
      this.rowIndex = _.cloneDeep(rowIndex);
    },
    activeNormalRow({ row, rowIndex }) {
      this.normalRow = row;
      this.normalRowIndex = rowIndex;
    },
    weightSearch(queryString, cb) {
      let programList = this.weightList;
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    querySearch(queryString, cb) {
      let categoryList = this.categoryList;
      // 调用 callback 返回建议列表的数据
      let results = queryString ? categoryList.filter(this.createFilter(queryString)) : categoryList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (categoryList) => {
        return categoryList.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1;
      };
    },
    async copyData(row, index) {
      const $table = this.$refs.week;
      const item = _.cloneDeep(row);
      delete item._XID;
      delete item.id;
      item.status = 100;
      item.source = 0;
      let length = 0;
      if (index <= this.kpiLength) {
        this.kpi.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength]);
        length = this.kpiLength;
      } else if (index > this.kpiLength + 1 && index <= this.createLength + this.kpiLength + 2) {
        this.create.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength + 1 + this.createLength]);
        length = this.kpiLength + 1 + this.createLength;
      } else {
        this.other.push(item);
        await $table.setActiveRow(this.tableData[this.kpiLength + 2 + this.createLength + this.otherLength]);
        length = this.kpiLength + 2 + this.createLength + this.otherLength;
      }
      // this.$nextTick(() => {
      //   this.saveAuto(item, index + 1);
      // });
    },
    copyNormal(row, index) {
      const item = _.cloneDeep(row);
      delete item._XID;
      delete item.id;
      item.status = 100;
      item.source = 0;
      this.normal.push(item);
      const $table = this.$refs.normal;
      $table.setActiveRow(this.normalTableData[this.normalLength]);
    },
    deleteData(row, index, alert = 1) {
      this.$confirm('确定要删除吗', '删除', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          if (row.id) {
            this.$ajax.post(this.$api.workManage.week.delete, [row.id]).then(() => {
              const item = row;
              if (item.workClassify === 0) {
                _.remove(this.kpi, t => t.id == item.id);
                this.kpi.splice(0,0);
              }else if (item.workClassify === 20) {
                _.remove(this.create, t => t.id == item.id);
                this.create.splice(0,0);
              } else if (item.workClassify === 30) {
                _.remove(this.other, t => t.id == item.id);
                this.other.splice(0,0);
              }
              clearInterval(this.timer);
              if (alert) {
                this.$message.success('删除成功');
              }
            });
          } else {
            if (index <= this.kpiLength) {
              this.kpi.splice(index - 1, 1);
            } else if (index > this.kpiLength + 1 && index <= this.createLength + this.kpiLength + 2) {
              this.create.splice(index - this.kpiLength - 2, 1);
            } else {
              this.other.splice(index - this.kpiLength - this.createLength - 4, 1);
            }
            clearInterval(this.timer);
            if (alert) {
              this.$message.success('删除成功');
            }
          }
        });
    },
    deleteNormal(row, index, alert = 1) {
      this.$confirm('确定要删除吗', '删除', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => { 
          if (row.id) {
            this.$ajax.post(this.$api.workManage.week.delete, [row.id]).then(() => {
              _.remove(this.normal, t => t.id == row.id);
              this.normal.splice(0,0);
              clearInterval(this.timer);
              if (alert) {
                this.$message.success('删除成功');
              }
            });
          } else {
            this.normal.splice(index - 1, 1);
            clearInterval(this.timer);
            if (alert) {
              this.$message.success('删除成功');
            }
          }
      });
    },
    getSelect() {
      let check1 = this.$refs.week.getCheckboxRecords();
      let check2 = this.$refs.normal.getCheckboxRecords();
      let check = [...check1, ...check2];
      let data = check.filter((val) => val.workId !== undefined);
      const res = data.map((val) => {
        const { id, reason, completeStatus } = val;
        return { id: id, reason: reason, completeStatus: completeStatus };
      });
      return res;
    },
    move(row, rowIndex) {
      console.log(row, rowIndex);
      this.showHandle = true;
      this.nowClassify = row;
      this.classify = row.workClassify;
    },
    confirmClassify() {
      this.$confirm('确定要切换工作项分类吗', '切换分类', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        this.showHandle = false;
        this.nowClassify.workClassify = this.classify;
        this.$ajax.post(this.$api.workManage.week.updateDetail, [this.nowClassify]).then(() => {
          this.getList();
          this.$message.success('更改工作分类成功');
        });
      }).catch(() => {
        this.showHandle = false;
      });
    },
    getAddWork(row) {
      this.$ajax
        .get(
          this.$api.week.WeekWorkDetail.release,
          {
            id: row.id,
          },
          { noLoading: true }
        )
        .then((res) => {
          this.programData = res.data;
        });
    },
    checkAll(e) {
      if (e) {
        this.checkList = this.programData.map((val) => val.id);
      } else {
        this.checkList = [];
      }
    },
    copyProgram() {
      const arr = this.programData.filter((val) => this.checkList.indexOf(val.id) !== -1);
      if (arr.length === 0) {
        this.$message({
          message: '请先勾选数据',
          type: 'error',
        });
        return false;
      }
      let text = '';
      arr.forEach((val) => {
        text += val.address;
      });
      let oInput = document.createElement('input');
      oInput.value = text;
      oInput.className = 'copy-text';
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand('Copy'); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success',
      });
    },
    popupHistory(row) {
      if (row.source === 2) {
        this.showHistory = true;
        this.$ajax
          .get(
            this.$api.week.WeekWorkDetail.history,
            {
              id: row.id,
            },
            { noLoading: true }
          )
          .then((res) => {
            this.historyData = res.data;
          });
      }
    },
    openHistoryDialog() {
        
    },
    expandKpi() {
      this.setMerge();
      this.expandKpiStatus = !this.expandKpiStatus;
      if (this.expandKpiStatus) {
        this.kpi = _.cloneDeep(this.cloneKpi);
      } else {
        this.cloneKpi = _.cloneDeep(this.kpi);
        this.kpi = [];
      }
    },
    expandNormal() {
      this.expandNormalStatus = !this.expandNormalStatus;
      if (this.expandNormalStatus) {
        this.normal = _.cloneDeep(this.cloneNormal);
        this.cloneNormal = [];
      } else {
        this.cloneNormal = _.cloneDeep(this.normal);
        this.normal = [];
      }
    },
    expandCreate() {
      this.setMerge();
      this.expandCreateStatus = !this.expandCreateStatus;
      if (this.expandCreateStatus) {
        this.create = _.cloneDeep(this.cloneCreate);
        this.cloneCreate = [];
      } else {
        this.cloneCreate = _.cloneDeep(this.create);
        this.create = [];
      }
    },
    expandOther() {
      this.setMerge();
      this.expandOtherStatus = !this.expandOtherStatus;
      if (this.expandOtherStatus) {
        this.other = _.cloneDeep(this.cloneOther);
        this.cloneOther = [];
      } else {
        this.cloneOther = _.cloneDeep(this.other);
        this.other = [];
      }
    },
    expandAll() {
      if (!this.expandKpiStatus) {
        this.expandKpiStatus = !this.expandKpiStatus;
        this.kpi = _.cloneDeep(this.cloneKpi);
      }
      if (!this.expandCreateStatus) {
        this.expandCreateStatus = !this.expandCreateStatus;
        this.create = _.cloneDeep(this.cloneCreate);
      }
      if (!this.expandOtherStatus) {
        this.expandOtherStatus = !this.expandOtherStatus;
        this.other = _.cloneDeep(this.cloneOther);
      }
    },
    changeModel(e) {
      const arr = this.tableColumn.filter((val) => val.title !== undefined);
      const arr1 = this.normalColumn.filter((val) => val.title !== undefined);
      let list = [];
      switch (e) {
        case '1':
          list = [];
          this.tableColumn.forEach((val) => {
            val.visible = true;
          });
          this.normalColumn.forEach((val) => {
            val.visible = true;
          });
          this.isCollapse = false;
          this.isNormalCollapse = false;
          setTimeout(() => {
            this.setPosition(null, 'kpi');
            // this.observerClass("kpi");
            this.setPosition(null, 'normal');
            // this.observerClass("normal");
          }, 50);
          break;
        case '2':
          list = ['类别', '工作项目', '总目标', '总目标完成时间', '本周需达到的目标', '本周目标完成时间', '权重', '提交状态', '操作'];
          this.showCollapse = false;
          break;
        case '3':
          list = ['类别', '工作项目', '总目标', '总目标完成时间', '本周需达到的目标', '本周目标完成时间', '完成情况', '总结', '提交状态', '操作'];
          this.isCollapse = false;
          this.isNormalCollapse = false;
          setTimeout(() => {
            this.setPosition(null, 'kpi');
            // this.observerClass("kpi");
            this.setPosition(null, 'normal');
            // this.observerClass("normal");
          }, 50);
          break;
        case '4':
          list = ['工作项目', '本周需达到的目标', '完成情况', '总结'];
          this.showCollapse = false;
          break;
      }
      if (list.length) {
        arr.forEach((val) => {
          if (list.indexOf(val.title) !== -1) {
            val.visible = true;
          } else {
            val.visible = false;
          }
        });
        arr1.forEach((val) => {
          if (list.indexOf(val.title) !== -1) {
            val.visible = true;
          } else {
            val.visible = false;
          }
        });
      }
      let promise1 = this.$refs.week.refreshColumn();
      let promise2 = this.$refs.normal.refreshColumn();
      Promise.all([promise1, promise2]).then(() => {
        if (e == 2) {
          if (this.currentTab === 0) {
            if (document.getElementsByClassName('kpi')[0].getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
              setTimeout(() => {
                this.setPosition(null, 'kpi');
              }, 50);
            } else {
              this.showCollapse = false;
            }
          } else {
            if (document.getElementsByClassName('normal')[0].getElementsByClassName('vxe-table--fixed-right-wrapper')[0]) {
              setTimeout(() => {
                this.setPosition(null, 'normal');
              }, 50);
            } else {
              this.showCollapse = false;
            }
          }
        }
      });
    },
    setMerge() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + this.createLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ];
    },
    setNormalMerge() {
      this.mergeNormal = [{ row: 0, col: 0, rowspan: 1, colspan: this.normalColumnLength }];
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit('common/updatePreMenu', {
        url: from.fullPath,
        name: from.meta.title,
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('common/updatePreMenu', null);
    next(true);
    //   // 导航离开该组件的对应路由时调用
    //   // 可以访问组件实例 `this`
    //
  },
  watch: {
    tableColumnLength() {
      this.mergeCells = [
        { row: 0, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + 1, col: 0, rowspan: 1, colspan: this.tableColumnLength },
        { row: this.kpiLength + this.createLength + 2, col: 0, rowspan: 1, colspan: this.tableColumnLength },
      ];
    },
    normalColumnLength() {
      this.mergeNormal = [{ row: 0, col: 0, rowspan: 1, colspan: this.normalColumnLength }];
    },
    kpiLength() {
      this.setMerge();
    },
    normalLength() {
      this.setNormalMerge();
    },
    createLength() {
      this.setMerge();
    },
    otherLength() {
      this.setMerge();
    },
  },
};
</script>
<style scoped lang="scss">
.week {
  height: 100%;
  .header {
    .week-title {
      border-right: 1px solid #eaeef4;
      padding: 0 10px;
      h2 {
        color: $--color-text-primary;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
      }
      .saveStatus {
        margin-left: 10px;
        font-size: 15px;
        color: #8e9694;
      }
    }
  }
  .container {
    margin-top: 15px;
    flex: 1;
    .search {
      .atb-input {
        display: flex;
        .flex-form-item {
          display: flex;
          flex: 1;
          margin-bottom: 12px;
        }
        ::v-deep.el-form-item__content {
          flex: 1;
          .el-select,
          .el-autocomplete {
            width: 100%;
          }
        }
      }
    }
    .table-content {
      position: relative;
      .collapse {
        position: absolute;
        cursor: pointer;
        width: 15px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: rgba(#000, 0.1);
        z-index: 99;
        top: -100px;
        &:hover {
          background-color: rgba(#000, 0.2);
        }
        i {
          font-size: 14px;
          color: #fff;
        }
      }
    }
    .kpi-content {
      overflow: auto;
      flex-grow: 1;
    }
    ::v-deep .header-table {
      overflow: auto;
      flex-grow: 1;
      user-select: text;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .main-row {
        .vxe-cell {
          padding: 0;
        }
      }
    }
    .kpi-add {
      height: 47px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      padding: 0 15px;
      div {
        cursor: pointer;
        span {
          margin-right: 15px;
        }
        i.fold {
          margin-right: 5px;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: left;
    .sub-content {
      text-align: center;
    }
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: right;
  }
}
::v-deep .el-radio {
  margin-right: 10px;
}
::v-deep .el-radio-button {
  margin-right: 20px;
  margin-bottom: 15px;
  .el-radio-button__inner {
    border-radius: 20px;
    padding: 0 20px;
    width: 100%;
    line-height: 36px;
    border: 1px solid $--color-primary;
    color: $--color-primary;
  }
}
::v-deep .el-radio-button.is-active .el-radio-button__inner {
  color: $--color-white;
}
.program-check {
  li {
    &:not(:last-child) {
      padding-bottom: 20px;
    }
    .el-checkbox__label {
      span {
        font-weight: bold;
      }
    }
    div {
      flex-grow: 1;
      margin-left: 15px;
      p {
        color: $--color-text-primary;
        font-size: 14px;
        &.desc {
          line-height: 1.5;
        }
        &.date {
          line-height: 1;
          margin-top: 10px;
        }
      }
    }
  }
}
.history-dialog{
  .content{
    height: 450px;
  }
}
.footer {
  text-align: right;
  margin-top: 20px;
  .select-all-program {
    margin-right: 20px;
  }
}
.source-icon {
  font-size: 22px;
  &.add {
    color: #22b6a1;
  }
  &.self {
    color: #ffbe4a;
  }
  &.year {
    color: #4ece7d;
  }
  &.pre {
    color: #40c3f2;
  }
  &.todo {
    color: #878a00;
  }
}
</style>
